import { inEnum, isObject } from "@ciaopeople/cp-shatsu/TypeChecking";

export type GoogleCredentialResponse = {
    clientId?: string,
    credential: string,
    select_by?: string
};



export enum GoogleOneTapDismissReason {
    credential_returned = "credential_returned",
    cancel_called = "cancel_called",
    flow_restarted = "flow_restarted"
}



export enum GoogleOneTapMomentType  {
    skipped =  "skipped",
    dismissed = "dismissed"
}

export interface GoogleOneTapPromptNotification {
       moment: GoogleOneTapMomentType
       dismissReason?: GoogleOneTapDismissReason,   
}


export function isGoogleOneTapPromptNotification(obj: any): obj is GoogleOneTapPromptNotification {
    return isObject(obj) &&
        ("moment" in obj && inEnum(obj.moment, GoogleOneTapMomentType)) &&
        (!("dismissReason" in obj) || inEnum(obj.dismissReason, GoogleOneTapDismissReason));
}
export interface OneTapDelegate {


    oneTapDelegateLogin(): Promise<GoogleCredentialResponse>
    oneTapDelegateRevoke(hint: string, isDeleteRequest: boolean): Promise<boolean>
}